"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setLocale = exports.setUpWorkspace = exports.setUpUser = exports.extractErrorMessage = exports.client = void 0;
const axios_1 = require("axios");
const lodash_1 = require("lodash");
exports.client = axios_1.default.create({
    baseURL: process.env.REACT_APP_API_ENDPOINT,
    headers: { 'Content-Type': 'application/json' },
    timeout: 9500
});
let internalJwt;
const patchAPIClientJWT = (jwt) => {
    internalJwt = jwt;
};
let internalWorkspaceId;
const patchAPIClientWorkspaceId = (workspaceId) => {
    window.localStorage.setItem('activeWorkspaceId', workspaceId);
    internalWorkspaceId = workspaceId;
};
let internalLocale = 'en-US';
const patchAPIClientLocale = (locale) => {
    internalLocale = locale;
};
exports.client.interceptors.request.use((clientConfig) => {
    if (internalJwt) {
        clientConfig.headers.Authorization = `Bearer ${internalJwt}`;
    }
    if (internalWorkspaceId) {
        clientConfig.headers['X-Workspace-Id'] = internalWorkspaceId;
    }
    if (internalLocale) {
        clientConfig.headers['X-Locale'] = internalLocale;
    }
    return clientConfig;
});
exports.client.interceptors.response.use((response) => {
    return response;
}, (error) => {
    if (401 === error.response.status) {
        patchAPIClientJWT(undefined);
        console.warn('Koopa 401 API Exception. Triggering a full app reload.');
        window.location.reload();
    }
    return Promise.reject(error);
});
const extractErrorMessage = (error) => {
    const statusCode = lodash_1.get(error, 'response.data.error.statusCode');
    const errorMessage = lodash_1.get(error, 'response.data.error.message', error);
    return `Error ${statusCode}: ${errorMessage}`;
};
exports.extractErrorMessage = extractErrorMessage;
const setUpUser = async (jwt) => {
    // 1. Add JWT to all API requests
    await patchAPIClientJWT(jwt);
    // 2. Get user profile and workspace
    const [{ data: { workspaces } }, { data: { user } }] = await axios_1.default.all([exports.client.get('/workspaces'), exports.client.get('/users/me')]);
    // 3. Set active workspace
    let activeWorkspaceId = workspaces.length > 0 ? workspaces[0].id : null;
    const savedActiveWorkspaceId = window.localStorage.getItem('activeWorkspaceId');
    if (savedActiveWorkspaceId) {
        if (workspaces.find(({ id }) => savedActiveWorkspaceId === id)) {
            activeWorkspaceId = savedActiveWorkspaceId;
        }
    }
    // 4. Patch API for active workspace
    if (activeWorkspaceId) {
        await patchAPIClientWorkspaceId(activeWorkspaceId);
    }
    // 5. Dispatch new state
    return { activeWorkspaceId, workspaces, me: user };
};
exports.setUpUser = setUpUser;
const setUpWorkspace = async (workspaceId) => {
    await patchAPIClientWorkspaceId(workspaceId);
};
exports.setUpWorkspace = setUpWorkspace;
const setLocale = async (locale) => {
    await patchAPIClientLocale(locale);
};
exports.setLocale = setLocale;
//# sourceMappingURL=Api.js.map